export default __webpack_public_path__ + "static/media/joytcp-1.f2778c40.png";